import { useState, useEffect } from 'react';

function HeroSection({ onOpenPayment, onOpenPaymentPage, pricing = { price1Friend: 4000 }, ctaRef }) {
  const [timeLeft, setTimeLeft] = useState({ minutes: 4, seconds: 58 });

  const price1 = pricing.price1Friend;
  const originalPrice1 = price1 * 2.5;
  const discount1 = Math.round((1 - price1 / originalPrice1) * 100);
  const savings1 = originalPrice1 - price1;

  const formatPrice = (num) => '₹' + Number(num).toLocaleString('en-IN');

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return { ...prev, seconds: prev.seconds - 1 };
        if (prev.minutes > 0) return { minutes: prev.minutes - 1, seconds: 59 };
        return { minutes: 4, seconds: 58 };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center py-20 overflow-hidden bg-black">
      {/* Animated Background */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-amber-900/20 via-black to-black"></div>
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-amber-500/10 rounded-full blur-[120px] animate-pulse"></div>
        <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-orange-500/10 rounded-full blur-[100px] animate-pulse delay-1000"></div>
        
        {/* Floating Particles */}
        <div className="absolute top-20 left-10 w-2 h-2 bg-amber-400/60 rounded-full animate-float"></div>
        <div className="absolute top-40 right-20 w-3 h-3 bg-amber-500/40 rounded-full animate-float-delayed"></div>
        <div className="absolute bottom-40 left-20 w-2 h-2 bg-orange-400/50 rounded-full animate-float"></div>
        <div className="absolute top-1/2 right-10 w-4 h-4 bg-yellow-400/30 rounded-full animate-float-delayed"></div>
        
        {/* Grid Pattern */}
        <div className="absolute inset-0 bg-[linear-gradient(rgba(251,191,36,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(251,191,36,0.03)_1px,transparent_1px)] bg-[size:50px_50px]"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Heading */}
         <div className="max-w-2xl mx-auto mb-10 animate-fade-in-up delay-200">
          <div className="relative group">
            <div className="absolute -inset-1 bg-gradient-to-r from-red-600 to-red-900 rounded-2xl blur opacity-40 group-hover:opacity-60 transition duration-500 animate-glow-pulse"></div>
            <div className="relative bg-red-950/80 border-2 border-red-500/50 rounded-2xl p-5 backdrop-blur-sm animate-border-pulse-red">
              <p className="text-red-400 font-bold text-lg md:text-xl text-center flex items-center justify-center gap-3">
                <span className="text-2xl animate-pulse">⚠️</span>
                "BAD NEWS" For Slow Paying Customers
                <span className="text-2xl animate-pulse">⚠️</span>
              </p>
            </div>
          </div>
        </div>
        <div className="text-center max-w-4xl mx-auto mb-10 animate-fade-in-up">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black mb-6 leading-tight tracking-tight">
            <span className="text-white">Get Your</span>
            <br />
            <span className="relative inline-block">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 via-yellow-400 to-orange-500 animate-gradient-x">
                Blocked Payments
              </span>
              <svg className="absolute -bottom-2 left-0 w-full" viewBox="0 0 300 12" fill="none">
                <path d="M2 10C50 4 100 4 150 7C200 10 250 6 298 2" stroke="url(#gold-gradient)" strokeWidth="3" strokeLinecap="round"/>
                <defs><linearGradient id="gold-gradient" x1="0" y1="0" x2="300" y2="0"><stop stopColor="#F59E0B"/><stop offset="1" stopColor="#F97316"/></linearGradient></defs>
              </svg>
            </span>
            <br />
            <span className="text-white">Back</span>
          </h1>
          
          <p className="text-lg sm:text-xl md:text-2xl text-gray-400 leading-relaxed max-w-3xl mx-auto">
            Without Investing Your <span className="text-white font-semibold">Time</span>, <span className="text-white font-semibold">Energy</span>, <span className="text-white font-semibold">Efforts</span> Even if the Money has been Stuck for <span className="text-amber-400 font-semibold">Years</span>.
          </p>
        </div>

        {/* Warning Box */}
       

        {/* Stats Box */}
        <div className="max-w-3xl mx-auto mb-12 animate-fade-in-up delay-300">
          <div className="relative group">
            <div className="absolute -inset-1 bg-gradient-to-r from-amber-500/50 to-orange-500/50 rounded-3xl blur opacity-30 group-hover:opacity-50 transition duration-500"></div>
            <div className="relative bg-gray-900/90 border border-gray-800 rounded-3xl p-6 md:p-8 backdrop-blur-sm">
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-center leading-relaxed">
                <span className="text-white">My Single Recovery Notice Has Helped Businesses Recover</span>
                <br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-400 text-3xl sm:text-4xl md:text-5xl font-black mt-2 inline-block animate-pulse">
                  ₹10 Crores+
                </span>
              </h2>
              <p className="text-amber-400 font-semibold text-lg md:text-xl text-center mt-4">
                Now It's Your Turn to Get Your Money Back From Bad Paying Customers.
              </p>
            </div>
          </div>
        </div>

        <div className="relative mb-12 max-w-4xl mx-auto animate-fade-in-up delay-400">
          <div className="relative group">
            {/* Glowing Border Effect */}
            <div className="absolute -inset-1 bg-gradient-to-r from-amber-500 via-orange-500 to-amber-500 rounded-2xl blur-lg opacity-40 group-hover:opacity-70 transition-all duration-500"></div>
            
            {/* Video Container */}
            <div className="relative bg-gray-900 rounded-2xl overflow-hidden border border-amber-500/30 shadow-2xl shadow-amber-500/10">
              <div className="aspect-video">
                <iframe
                  src="https://www.youtube.com/embed/4fvxDzVs8TM"
                  className="w-full h-full"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="Blocked Payments Recovery Training Preview"
                ></iframe>
              </div>
            </div>
            
            {/* Decorative Elements */}
            <div className="absolute -top-4 -right-4 w-8 h-8 bg-amber-500 rounded-full blur-md opacity-50"></div>
            <div className="absolute -bottom-4 -left-4 w-6 h-6 bg-orange-500 rounded-full blur-md opacity-50"></div>
          </div>
          
          {/* Video Caption */}
          <p className="text-center text-gray-400 mt-4 text-sm">
            <span className="text-amber-400">▶</span> Watch to learn how to recover your blocked payments
          </p>
        </div>

      
        {/* CTA Cards - Two Options */}
        <div className="max-w-2xl mx-auto animate-fade-in-up delay-500 px-4">
          <div className="grid grid-cols-1 gap-6 items-stretch">
            {/* Card 1 - Single Seat ₹4,000 */}
            <div className="relative group h-full">
              <div className="absolute -inset-1 bg-gradient-to-r from-amber-500/40 via-orange-500/40 to-amber-500/40 rounded-3xl blur-xl opacity-60"></div>
              <div className="relative bg-gradient-to-br from-slate-800 via-slate-900 to-slate-800 rounded-3xl border border-amber-500/30 p-6 text-center overflow-hidden shadow-2xl h-full flex flex-col justify-between">
                <div>
                  {/* Spacer for badge alignment */}
                  <div className="h-6 mb-2"></div>
                  
                  {/* Timer */}
                  <div className="mb-4">
                    <p className="text-gray-400 text-xs mb-3 uppercase tracking-widest font-medium">Offer Expires In</p>
                    <div className="flex items-center justify-center gap-2">
                      <div className="relative">
                        <div className="absolute inset-0 bg-red-500 rounded-xl blur-sm opacity-40"></div>
                        <div className="relative bg-gradient-to-br from-red-500 to-red-700 text-white w-14 h-14 rounded-xl flex items-center justify-center text-2xl font-black shadow-lg border border-red-400/30">
                          {String(timeLeft.minutes).padStart(2, '0')}
                        </div>
                        <p className="text-gray-500 text-[9px] mt-1 uppercase tracking-wider">Minutes</p>
                      </div>
                      <span className="text-2xl font-black text-amber-500 animate-pulse mb-5">:</span>
                      <div className="relative">
                        <div className="absolute inset-0 bg-red-500 rounded-xl blur-sm opacity-40"></div>
                        <div className="relative bg-gradient-to-br from-red-500 to-red-700 text-white w-14 h-14 rounded-xl flex items-center justify-center text-2xl font-black shadow-lg border border-red-400/30">
                          {String(timeLeft.seconds).padStart(2, '0')}
                        </div>
                        <p className="text-gray-500 text-[9px] mt-1 uppercase tracking-wider">Seconds</p>
                      </div>
                    </div>
                  </div>

                  {/* Warning */}
                  <p className="text-red-400 text-sm md:text-base font-bold mb-4">
                    Price rises to {formatPrice(originalPrice1)} after timer ends!
                  </p>

                  {/* Pricing */}
                  <div className="mb-4">
                    <p className="text-red-500 line-through text-xl font-black">{formatPrice(originalPrice1)}</p>
                    <div className="flex items-center justify-center gap-2">
                      <span className="text-4xl md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-400">
                        {formatPrice(price1)}
                      </span>
                      <span className="bg-green-500/20 text-green-400 text-xs font-bold px-2 py-1 rounded-full border border-green-500/30">
                        {discount1}% OFF
                      </span>
                    </div>
                    <p className="text-green-400 font-semibold mt-2 flex items-center justify-center gap-1 text-sm">
                      <span>🎉</span> Save {formatPrice(savings1)} Today!
                    </p>
                  </div>
                </div>

                {/* CTA Button */}
                <button 
                  ref={ctaRef}
                  onClick={() => onOpenPaymentPage(price1)}
                  className="group/btn relative inline-flex items-center justify-center w-full py-4 px-6 text-base font-bold text-black bg-gradient-to-r from-amber-400 via-yellow-400 to-orange-500 rounded-xl shadow-lg shadow-amber-500/30 overflow-hidden transition-all duration-300 hover:scale-[1.02] hover:shadow-amber-500/50"
                >
                  <span className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 -translate-x-full group-hover/btn:translate-x-full transition-transform duration-700"></span>
                  <span className="relative flex items-center gap-2">
                    Yes, I Want This
                    <svg className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                    </svg>
                  </span>
                </button>
              </div>
            </div>


          </div>
        </div>

     
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce hidden md:block">
          <div className="w-8 h-12 rounded-full border-2 border-amber-500/50 flex items-start justify-center p-2">
            <div className="w-1.5 h-3 bg-amber-500 rounded-full animate-scroll"></div>
          </div>
        </div>
      </div>

      
      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(180deg); }
        }
        @keyframes float-delayed {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-15px); }
        }
        @keyframes gradient-x {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
        @keyframes scroll {
          0%, 100% { transform: translateY(0); opacity: 1; }
          50% { transform: translateY(6px); opacity: 0.5; }
        }
        @keyframes fade-in-down {
          from { opacity: 0; transform: translateY(-20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fade-in-up {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-float { animation: float 6s ease-in-out infinite; }
        .animate-float-delayed { animation: float-delayed 5s ease-in-out infinite 1s; }
        .animate-gradient-x { animation: gradient-x 3s ease infinite; background-size: 200% 200%; }
        .animate-scroll { animation: scroll 1.5s ease-in-out infinite; }
        .animate-fade-in-down { animation: fade-in-down 0.8s ease-out forwards; }
        .animate-fade-in-up { animation: fade-in-up 0.8s ease-out forwards; }
        .delay-200 { animation-delay: 0.2s; opacity: 0; }
        .delay-300 { animation-delay: 0.3s; opacity: 0; }
        .delay-500 { animation-delay: 0.5s; opacity: 0; }
        @keyframes glow-pulse {
          0%, 100% { opacity: 0.4; transform: scale(1); }
          50% { opacity: 0.8; transform: scale(1.05); }
        }
        @keyframes border-pulse-red {
          0%, 100% { border-color: rgba(239, 68, 68, 0.5); box-shadow: 0 0 20px rgba(239, 68, 68, 0.5); }
          50% { border-color: rgba(239, 68, 68, 1); box-shadow: 0 0 40px rgba(239, 68, 68, 0.8), 0 0 60px rgba(239, 68, 68, 0.6); }
        }
        .animate-glow-pulse { animation: glow-pulse 2s ease-in-out infinite; }
        .animate-border-pulse-red { animation: border-pulse-red 2s ease-in-out infinite; }
      `}</style>
    </section>
  );
}

export default HeroSection;
